import { h, Component } from 'preact';
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import constants from "../constants";
import Spinner from './Spinner'
import imageService from '../service/imageService';
import Cropper from "react-cropper";
import 'cropperjs/dist/cropper.min.css'
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import util from "../util";
import store from "../store";
import MOBackIcon from "./svg/MOBackIcon";
import React from "preact/compat";
import { EditOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

export default @connect(reduce, actions)

class MenuIconEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUploadLoading: false,
      isLoading: false,
      uploadErrMsg: '',

      isCropping: false,
      imageCropSrc: '',
      cropResult: null,
      iconColor: '',
      showMenu: false
    };

    this.getCurrentColor = () => {
      if (this.props.activeIcons[this.props.activeIconIdx]['fill']) {
        return this.props.activeIcons[this.props.activeIconIdx]['fill'];
      } else {
        return this.props.menuObjectStyles['icon-entry'] ? this.props.menuObjectStyles['icon-entry']['color'] : ''
      }
    }

    this.setOrToggleActiveIcon = (icon) => {
      const idx = this.props.activeIcons.indexOf(icon);
      if (this.props.activeIconIdx === idx) {
        this.props.setActiveIconIdx(null);
        if (this.props.view === 'color-picker') {
          this.props.goToView('text-mo');
          this.props.goToSubview('add-new');
        }
      } else {
        this.props.setActiveIconIdx(idx);
        if (this.props.view === 'color-picker') {
          util.nextTick(() => {
            this.props.openColorPicker();
          })
        }
      }
      this.forceUpdate();
    }
  }

  editIcon(activeIdx, iconKey, iconType, color, altText="", source="") {
    if (store.getState().isMobileVersion && $('.modal-content').length && !(typeof this.props.activeIcons !== 'undefined' && this.props.activeIcons !== null && this.props.activeIcons[this.props.activeIconIdx] != null)) {
      $('.modal-content').scrollTop(0);
    }

    function addIcon(this1) {
      this1.props.editIcon(activeIdx, iconKey, iconType, color, altText, source);
      this1.forceUpdate();
    }

    if (activeIdx === null) {
      activeIdx = this.props.activeIcons.length;
      if (this.props.activeIcons.length < constants.maxMenuItemIcons) {
        addIcon(this);
      }
    } else {
      addIcon(this);
    }
  }

  editIconUpload(icon, event) {
    event.stopPropagation();
    store.dispatch(actions.setIsAltTextModal(true));
    store.dispatch(actions.setSelectedUploadedIcon(icon));
  }

  openCropper(image, event) {
    event.stopPropagation();

    this.setState({
      isCropping: true,
      //imageCropSrc: constants.urlPrefix + '/api/image/s3/' + image.id,
      imageCropSrc: image,
      isLoading: false
    })
  }

  closeCropper() {
    this.setState({
      isCropping: false,
      imageCropSrc: '',
      isLoading: false
    })
  }

  zoom(zoomValue) {
    if (typeof this.cropper.cropper.zoom() === "undefined") {
      return;
    }
    this.cropper.cropper.zoom(zoomValue);
  }

  cropImage() {
    if (typeof this.cropper.cropper.getCroppedCanvas() === "undefined") {
      return
    }

    this.setState({
      cropResult: this.cropper.cropper.getCroppedCanvas().toDataURL(),
      isLoading: true
    });

    this.cropper.cropper.getCroppedCanvas({
      maxWidth: 1024,
      maxHeight: 1024,
      imageSmoothingEnabled: 'false',
    }).toBlob((blob) => {
      if (blob) {
        const formData = new FormData();
        // Pass the image file name as the third parameter if necessary.
        formData.append('images', blob, util.UUID.get() + '_cropped.png');

        this.setState({ isUploadLoading: true });

        formData.append("locationId", this.props.locationId);
        const promise = this.props.isLogged ?
          imageService.uploadMemberIcon(this.props.memberId, formData) :
          imageService.uploadVisitorIcon(this.props.visitorId, formData);

        promise.then(response => {
          const newIcon = response.data;
          this.props.setUploadedIcons([...newIcon, ...this.props.uploadedIcons]);
          this.setState({
            isUploadLoading: false,
            isCropping: false,
            imageCropSrc: '',
            isLoading: false
          })
          store.dispatch(actions.setIsAltTextModal(true));
          store.dispatch(actions.setSelectedUploadedIcon(newIcon[0]));
          store.dispatch(actions.setIsJustUploaded(true));
        }).catch(err => {
          this.setState({ isUploadLoading: false });
        })
      }
    })
  }

  onChange(event) {
    const files = event.target.files;
    const formData = new FormData();

    if (!files.length) return;
    if (files[0].type.indexOf('image') === -1) {
      window.InfoModal.show({
        title: 'File type not supported!',
        body: 'Supported file types are jpg/jpeg and png.',
        acceptLabel: 'Got it',
      })
      return;
    }

    Array.from(Array(files.length).keys())
      .map(x => {
        formData.append('images', files[x], files[x].name)
      });
    this.readURL(event.target, event);
    event.target.value = '';
  }

  readURL(input, event) {
    let $that = this;
    if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        //$('#your_img').attr('src', e.target.result);
        $that.openCropper(e.target.result, event);
      }
      reader.readAsDataURL(input.files[0]);
    }
  }

  uploadIconUpgrade() {
    try {
      if (!this.props.hasPdfPermission) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
      }
    } catch (err) {
      console.log(err.stack);
    }
  }

  onIconClick() {
    this.setState({ showMenu: !this.state.showMenu });
  }

  componentDidMount() {
    $('.iconSettings').on('click', (ev) => {
      const $target = $(ev.target);
      if ($target.closest('.iconChoice').length === 0 &&
        $target.closest('.iconChoiceWithClear').length === 0 &&
        $target.closest('.iconColor').length === 0) {
        this.props.setActiveIconIdx(null);
      }
    });
  }

  render(props, state) {
    const activeIcon = (typeof props.activeIcons !== 'undefined' && props.activeIcons !== null && props.activeIcons[props.activeIconIdx] != null) ? props.activeIcons[props.activeIconIdx] : null
    const iconEntryColor = props.menuObjectStyles['icon-entry'] ? props.menuObjectStyles['icon-entry']['color'] : '';
    const itemNameColor = props.menuObjectStyles['name'] ? props.menuObjectStyles['name']['color'] : ''
    const color = (activeIcon !== null && activeIcon.fill) ? activeIcon.fill : (iconEntryColor || itemNameColor || constants.DEFAULT_TEXT_COLOR);

    const currentMenuIconsJsx = (
      <ul className="iconLibrarySectionList">
        {props.activeIcons.map(icon => {
          return (
            <li className={`iconChoice ${props.activeIconIdx === props.activeIcons.indexOf(icon) ? 'selected' : ''}`} onClick={() => this.setOrToggleActiveIcon(icon)}>
              {
                icon.type === 'svg' ?
                  <svg className="icon-entry" width="28px" height="28px" fill={icon.fill ? icon.fill : iconEntryColor}>
                    <use xlinkHref={constants.appPrefix + '/svg/icon-library/menu-icons.svg#' + icon.iconKey}> </use>
                  </svg>
                : icon.type === 'letter' ?
                <span className="icon-entry" width="28px" height="28px" style={`color: ${icon.fill ? icon.fill : iconEntryColor};`}>
                  {icon.iconKey}
                </span>
                : icon.iconKey.includes("icon-uploads") ?
                  <img className="icon-entry" width="28px" height="28px" src={util.getUploadedIconPath(icon)} />
                  :
                  <img className="icon-entry" width="28px" height="28px" src={constants.SECURE_S3_OO_PATH + icon.iconKey} />
              }
            </li>
          )
        })}
      </ul>
    )

    const menuActiveIconsJsx = (
      <ul className="iconLibrarySectionList">
        {props.menuActiveIcons.map(icon => {
          return (
            <li className={'iconChoice'} onClick={() => this.editIcon(props.activeIconIdx, icon.iconKey, icon.type, icon.fill, icon.altText ? icon.altText : '', icon.source ? icon.source : '')}>
              {
                icon.type === 'svg' ?
                  <svg className="icon-entry" width="28px" height="28px" role="img" aria-label={icon.altText}>
                    <use xlinkHref={constants.appPrefix + '/svg/icon-library/menu-icons.svg#' + icon.iconKey}> </use>
                  </svg>
                  : icon.type === 'letter' ?
                  <span className="icon-entry" width="28px" height="28px">
                    {icon.iconKey}
                  </span>
                  : icon.iconKey.includes("icon-uploads") ?
                    <img className="icon-entry" width="28px" height="28px" src={util.getUploadedIconPath(icon)} alt={icon.altText ? icon.altText : ''} />
                    :
                    <img className="icon-entry" width="28px" height="28px" src={constants.SECURE_S3_OO_PATH + icon.iconKey} alt={icon.altText ? icon.altText : ''} />
              }
            </li>
          )
        })}
      </ul>
    )

    function iconsList(list, this1) {
      return list.map((icon) =>
        <Tooltip placement='bottom' title={icon.hoverText ? icon.hoverText : ''} mouseLeaveDelay={0}>
          <div className={'iconChoice'} onClick={() => this1.editIcon(props.activeIconIdx, icon.iconKey, 'svg', color, icon.altText, 'timber')}>
            <svg role="img" aria-label={icon.altText}>
              <use xlinkHref={constants.appPrefix + '/svg/icon-library/menu-icons.svg/#' + icon.iconKey} />
            </svg>
          </div>
        </Tooltip>
      );
    }

    function letterIconsList(this1) {
      return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'].map((letter) => 
        <div className={'iconChoice'} onClick={() => this1.editIcon(props.activeIconIdx, letter, 'letter', color, '', 'timber')}>
          <span>{letter}</span>
        </div>
      )
    }

    const userUploadIconsList = props.uploadedIcons.map((icon) =>
      <div className="iconChoiceWithClear">
        <div className={'iconChoice uploaded'} onClick={() => this.editIcon(props.activeIconIdx, icon.path, icon.name.substring(icon.name.lastIndexOf('.') + 1), color, icon.altText, icon.source)}>
          <img src={util.getUploadedIconPath(icon)} alt={icon.altText} />
        </div>
        <div><button><EditOutlined onClick={(event) => this.editIconUpload(icon, event)} /></button></div>
      </div>
    );

    let uploadBox = null;
    if (state.isUploadLoading && !state.isCropping) {
      uploadBox = ''
    } else {
      uploadBox = this.props.hasPdfPermission ?
        <div>
          <input type="file" name="image" onChange={this.onChange.bind(this)} accept="image/jpeg,image/gif,image/png" className="input-file" multiple />
          <div className="uploadIcon iconChoice">+</div>
        </div>
        :
        <div onClick={() => this.uploadIconUpgrade()} style="cursor: default;">
          <div className="uploadIcon iconChoice">+</div>
        </div>
    }

    const uploadErrorMessage = state.uploadErrMsg ? <div className="upload-err">{state.uploadErrMsg}</div> : null

    const imageLoadingSpinner = (state.isLoading || state.isUploadLoading) ? <div className="spinnerWrapper"><Spinner /></div> : null

    const cropperFooterElement = state.isUploadLoading ? '' :
      <div className="footer">
        <div className={'zooms'}>
          <a className="pull-left zoomIn" onClick={() => this.zoom(0.1)}>
            <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-zoom-in"} /></svg>
          </a>
          <a className="pull-left zoomOut" onClick={() => this.zoom(-0.1)}>
            <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-zoom-out"} /></svg>
          </a>
        </div>
        <a className="btn primary pull-right" onClick={() => this.cropImage()}>Crop</a>
        <a className="btn tertiary pull-right" onClick={() => this.closeCropper()}>Cancel</a>
      </div>;

    const cropperElement = state.isCropping ?
      <div className="upload-cropper">
        <div className="container">
          <Cropper
            ref={cropper => {
              this.cropper = cropper;
            }}
            src={state.imageCropSrc}
            style={{ height: store.getState().isMobileVersion ? 485 : 310, width: 'auto' }}
            guides={true}
            zoomable={true}
            background={true}
            viewMode={0}
            checkCrossOrigin={false}
            aspectRatio={1}
          />
        </div>

        {cropperFooterElement}
      </div>
      : '';

    const iconColorPicker = (activeIcon !== null && (activeIcon.type === 'svg' || activeIcon.type === 'letter')) ?
      <div className="iconColor">
        <span className={'iconLibrarySectionLabel'}>Color</span>
        <div className="iconColorPicker">
          <a onClick={() => this.props.openColorPicker()}>
            <span className="color-box" style={`background: ${this.getCurrentColor()}; float: none;`}></span>
          </a>
        </div>
      </div>
      : '';

    const iconClearAll = <div className="iconClearAll" onClick={() => props.clearAllIcons()}>
      Clear All
    </div>

    const iconRemoveActive = (activeIcon !== null) ?
      <div className="iconRemoveActive" onClick={() => this.editIcon(props.activeIconIdx, 'deleteIcon')}>
        <DeleteOutlined />
      </div>
      : '';

    return (
      <div className="iconLibraryMenuObject">
        {props.isMobileVersion &&
          <header>
            <MOBackIcon onClick={() => props.setContentEditMode('item')} />
            <span>Add menu icon</span>
          </header>}
        <div className="iconSettings">
          {props.activeIcons.length > 0 &&
            <section className="iconLibrarySection thisItem">
              <div className='iconLibrarySectionLabel'>This Item</div>
              <div className='iconRemoveBtns'>
                {iconClearAll}
                {iconRemoveActive}
              </div>
              {currentMenuIconsJsx}
              {activeIcon && !this.state.isCropping &&
                iconColorPicker}
            </section>}

          {props.menuActiveIcons.length > 0 &&
            <section className="iconLibrarySection thisMenu">
              <div className="iconLibrarySectionLabel" style={props.activeIcons.length === 0 ? "margin-top: 0;" : ""}>This Menu</div>
              {menuActiveIconsJsx}
              <div className="iconDoubleSeparator" />
            </section>}

          <div className='iconLibraryLabel'>
            Icon Library
          </div>
          <section className="iconUploadTrigger">
            <div className="dropbox pull-right">
              {uploadErrorMessage}
            </div>
          </section>

          <section className="uploadControls">
            {cropperElement}
          </section>

          <section className='iconLibrarySection iconsUploadList'>
            <div className='iconLibrarySectionLabel'>Uploaded Icons</div>
            {imageLoadingSpinner}
            <span className={props.hasPdfPermission ? 'icon hidden' : 'icon'}>
              <img src="/imageservice/images/img/13/pay-modal/Pro2.svg" className="star-icon" />
            </span>

            {!state.isLoading &&
              <div className='iconLibrarySectionList'>
                {uploadBox}
                {userUploadIconsList}
              </div>}
          </section>

          <section className="iconLibrarySection">
            <div className="iconLibrarySectionLabel">General</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsGeneral, this)}
            </div>

            <div className="iconLibrarySectionLabel">Letters</div>
            <div className="iconLibrarySectionList">
              {letterIconsList(this)}
            </div>
            
            <div className="iconLibrarySectionLabel">Dietary Restrictions</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsDietary, this)}
            </div>

            <div className="iconLibrarySectionLabel">Gluten & Wheat</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsGlutenWheat, this)}
            </div>

            <div className="iconLibrarySectionLabel">Nuts & Seeds</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsNutsSeeds, this)}
            </div>

            <div className="iconLibrarySectionLabel">Seafood</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsSeafood, this)}
            </div>

            <div className="iconLibrarySectionLabel">Eggs & Dairy</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsEggsDairy, this)}
            </div>

            <div className="iconLibrarySectionLabel">Corn & Soy</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsCornSoy, this)}
            </div>

            <div className="iconLibrarySectionLabel">Keto & Low Carb</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsKeto, this)}
            </div>

            <div className="iconLibrarySectionLabel">Miscellaneous Allergens</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsMiscAllergens, this)}
            </div>

            <div className="iconLibrarySectionLabel">Happy Hour</div>
            <div className="iconLibrarySectionList">
              {iconsList(constants.menuIconsHappyHour, this)}
            </div>
          </section>
        </div>
      </div>
    )
  }
}
